import React from 'react';
import { Colors } from '~/themes/colors';

interface IDashedSeparatorProps {
  width?: number;
  color?: string;
  dash?: string;
  strokeWidth?: number;
  style?: React.CSSProperties;
}

export const DashedSeparator: React.FC<IDashedSeparatorProps> = ({
  width = 182,
  color = Colors.neutral_150,
  dash = '0.5 4',
  strokeWidth = 2,
  style,
}) => {
  return (
    <div
      style={{
        width,
        height: 4,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        ...style,
      }}
    >
      <svg width={width} height={strokeWidth} viewBox={`0 0 ${width} ${strokeWidth}`} fill="none">
        <path
          d={`M1 ${strokeWidth / 2} H${width - 1}`}
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={dash}
        />
      </svg>
    </div>
  );
};
